import React from 'react';
import { useHistory } from 'react-router-dom';

import { ResponsivePie } from '@nivo/pie';

import { UserStat } from '../../user/User.interface';

export interface EmployeeChartProps {
  stats: UserStat[];
}

const EmployeeChart: React.FC<EmployeeChartProps> = (
  props: EmployeeChartProps
) => {
  const history = useHistory();
  const { stats } = props;
  const chartColors = ['#61cdbb', '#F1E25B', '#f47560'];
  const formattedStats = stats.map((stat, index) => ({
    id: stat.id,
    label: stat.label,
    value: stat.value,
    color: chartColors[index]
  }));

  return (
    <div style={{ height: 300 }}>
      <ResponsivePie
        data={formattedStats}
        margin={{ top: 20, right: 60, bottom: 80, left: 60 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        colors={chartColors}
        onClick={data => {
          const status = data.id;
          history.push(`/portal/admin/trainees?status=${status}`);
        }}
        activeOuterRadiusOffset={8}
        borderWidth={1}
        borderColor={{ from: 'color', modifiers: [['darker', 0]] }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextOffset={6}
        arcLinkLabelsTextColor='#333333'
        arcLinkLabelsThickness={1}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor='#333333'
        legends={[
          {
            data: formattedStats.map(stat => ({
              id: stat.id,
              label: stat.id,
              color: stat.color
            })),
            anchor: 'bottom',
            direction: 'row',
            translateY: 56,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: '#999',
            symbolSize: 18,
            symbolShape: 'circle',
            effects: [
              {
                on: 'hover',
                style: {
                  itemTextColor: '#000'
                }
              }
            ]
          }
        ]}
      />
    </div>
  );
};

export default EmployeeChart;
